const ROLE_META = {
  admin: { label: "Ecosystem Admin", hex: "#144F75" },
  location_manager: { label: "Center Manager", hex: "#5C8A72" },
  enhancer: { label: "Enhancer Studio", hex: "#D98E73" },
};

export function roleMeta(role) {
  return ROLE_META[role] || ROLE_META.admin;
}

export default function RoleScopeBadge({ role, scopeName, testid = "role-scope-badge" }) {
  const meta = roleMeta(role);
  return (
    <div data-testid={testid} className="flex flex-col gap-1.5">
      <span
        className="inline-flex items-center gap-1.5 self-start rounded-full px-2.5 py-1 text-[10px] uppercase tracking-widest font-semibold text-white"
        style={{ backgroundColor: meta.hex }}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-white/80" />
        {meta.label}
      </span>
      {scopeName && (
        <span data-testid={`${testid}-scope`} className="text-xs text-white/60 truncate max-w-[16rem]">
          {scopeName}
        </span>
      )}
    </div>
  );
}
